import { colorSet } from '@components/Provider';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '15px 16px',
    background: colorSet.gray100,
    position: 'relative',
    '&:hover': {
      background: colorSet.gray200,
      cursor: 'pointer'
    },
    '&.active': {
      background: colorSet.gray200
    }
  },
  avatar: {
    marginRight: 16,
    '& .MuiAvatar-root': {
      width: 44,
      height: 44,
      backgroundColor: colorSet.gray000,
      '& img': {
        width: 44,
        height: 44
      }
    }
  },
  partner: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    width: '100%'
  },
  createdAt: {
    fontSize: '12px',
    lineHeight: '18px',
    color: colorSet.gray600,
    position: 'absolute',
    top: 20,
    right: 16
  },
  newChip: {
    width: 20,
    height: 20,
    borderRadius: '50%',
    backgroundColor: colorSet.errorBase,
    '& span': {
      padding: '4.5px 5.5px 5.5px',
      color: colorSet.gray000,
      textOverflow: 'unset'
    }
  },
  cost: {
    display: 'flex',
    justifyContent: 'space-between',
    '& .quotation': {
      '&.withdraw': {
        color: colorSet.gray500
      }
    }
  },
  labelBlock: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  }
}));

export default useStyles;
